import React from 'react';
import { FileUtil } from '../../../util/FileUtil';

const ObjectFw = ({config, ...restProps}) => {    
    let base64 = config.data.replace(`data:${config.data_type};base64,`,'')
    let blob = FileUtil.b64toBlob(base64, config.data_type);
    let blobUrl = window.URL.createObjectURL(blob);

    return (
        <embed
        src={blobUrl}
        // data={config.data} 
        // type={config.data_type}
        width="100%" 
        height="650">
        </embed>
    )
}
export default ObjectFw;